<p-confirmDialog key="confirmexception" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="exceptionresult" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Info-->
<div>
	<h4 style="text-align: center">
		<span class="InfoText">{{ PersonName }}</span> will be allowed in the selected facilties (Even if they are on the blocked list):
	</h4>
</div>

<!--Table-->
<div class="table-main-body TopMarign">
	<p-table
		#mydt
		[value]="lstFacility"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th>
					<p-columnFilter field="IsSelectedDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterIsSelectedDesc
								[ngModel]="value"
								[options]="lstIsSelectedDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--FacilityCD-->
				<th>
					<p-columnFilter type="text" field="FacilityCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--FacilityName-->
				<th>
					<p-columnFilter type="text" field="FacilityName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="IsSelectedDesc">Visitor Allowed in Facility<p-sortIcon field="IsSelectedDesc"></p-sortIcon></th>
				<th pSortableColumn="FacilityCD">Code<p-sortIcon field="FacilityCD"></p-sortIcon></th>
				<th pSortableColumn="FacilityName">Facility<p-sortIcon field="FacilityName"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Facility>
			<tr (click)="onUpdateCheck(Facility)">
				<td>
					<input [disabled]="IsLoading() == true" class="CHK" type="checkbox" [(ngModel)]="Facility.IsSelected" />
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ Facility[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onUpdateAll(true)">Select All</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary leftMargin" (click)="onUpdateAll(false)">Deselect All</button>

	<button [disabled]="IsLoading() == true" class="btn btn-success leftMargin" (click)="onUpdate()">Update</button>
	<button [disabled]="IsLoading() == true" class="btn btn-warning leftMargin" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
